import { createFileRoute } from "@tanstack/react-router";

import { DatasourcePage } from "~/pages/datasources/datasource.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/datasources/$datasourceId",
)({
  component: DatasourcePage,
});
